import i18next from 'i18next';
import { useTranslation as usei18nextTranslation } from 'react-i18next';

const NAMESPACE = 'INACTIVITY_TIMER';

i18next.addResources('es', NAMESPACE, {
  TITLE: 'Tu sesión ha expirado',
  BODY: 'Cerramos tu sesión ya que superaste el tiempo máximo de inactividad.',
  LOG_IN: 'Iniciar sesión',
});

i18next.addResources('en', NAMESPACE, {
  TITLE: 'Your session has expired',
  BODY: 'We have closed your session because you exceeded the maximum inactivity time.',
  LOG_IN: 'Log in',
});

i18next.addResources('pt', NAMESPACE, {
  TITLE: 'Sua sessão expirou',
  BODY: 'Fechamos sua sessão porque você excedeu o tempo máximo de inatividade.',
  LOG_IN: 'Logar',
});

export const useTranslation = () => usei18nextTranslation(NAMESPACE);
